export const WebStorageKey = {
  Token: 'token',
  IdToken: 'idToken',
  AccessToken: 'accessToken',
  RefreshToken: 'refreshToken',
  basicAuth: 'basicAuth',
  IAM: 'iam',
  UserInfo: 'userInfo',
  ServerTime: 'server_time',
  ClientTime: 'client_time',
  SCMCognitoToken: 'secom_cognito_token',
  LastVideoClipsSearchParams: 'last_video_clips_seach_params',
};

export const CameraFirmwareType = {
  firmware: 'FIRMWARE',
  arobaViewRa: 'ArobaView RA',
};

export const CameraStatus = {
  NoData: 'nodata',
  Error: 'error',
  Connected: 'connected',
  Loaded: 'loaded',
  Loading: 'loading',
};

export const PlayerStatus = {
  CanNotRecover: 'CanNotRecover',
  Discontinuity: 'discontinuity',
  FragmentLoaded: 'FragmentLoaded',
  FragmentChanged: 'FragmentChanged',
  FragmentBuffered: 'FragmentBuffered',
  FragmentStatusChanged: 'FragmentStatusChanged',
  PlaylistChanged: 'PlaylistChanged',
  CodecIsNotTheSame: 'CodecIsNotTheSame',
  StreamingSessionExpired: 'StreamingSessionExpired',
  NoFragmentChanged: 'NoFragmentChanged',
  OutOfRetentionPeriod: 'OutOfRetentionPeriod',
  Uknown: 'Uknown',
};

export const MimeTypes = {
  m3u: 'application/vnd.apple.mpegurl',
  mp4: 'video/mp4',
  m4a: 'video/mp4',
  ogg: 'video/ogg',
  mov: 'video/quicktime',
  webm: 'video/webm',
  wmv: 'video/x-ms-wmv',
  avi: 'video/x-msvideo',
};

export const EventBusEvents = {
  TrimEvent: 'sys-secom:trim-event',
  TrimEventComplete: 'sys-secom:trim-event-complete',
  CamGroupChanged: 'sys-secom:cam-group-changed',
  DisplayEvent: 'sys-secom:display-event',
  CallVideoStream: 'sys-secom:call-video-stream',
  VideoStreamErrorOpen: 'sys-secom:video-stream-error-open',
  HomeLayoutChanged: 'sys-secom:home-layout-changed',
  CameraListLoaded: 'sys-secom:camera-list-loaded',
  CallHomeEvents: 'sys-secom:home-events',
  AuthFailureCleanup: 'sys-secom:auth-failure-cleanup',
};

export const KVSErrorCodes = {
  GET_DATA_ENDPOINT: 'GET_DATA_ENDPOINT',
  GET_DATA_ENDPOINT_TOKEN_EXP: 'GET_DATA_ENDPOINT_TOKEN_EXP',
  GET_STREAMING_SESSION_URL: 'GET_STREAMING_SESSION_URL',
  NO_FRAGMENT_FOUND: 'NO_FRAGMENT_FOUND',
  OperationCanceled: 'OperationCanceled',
  ResourceNotFoundException: 'ResourceNotFoundException',
};

export const CommonErrorCodes = {
  NETWORK_ERROR: 'NETWORK_ERROR',
};

export const HTTPHeaders = {
  XAuthorization: 'X-Authorization',
  Authorization: 'Authorization',
  XArobaViewUserToken: 'X-ArobaView-User-Token',
};

export const FetchCamRecordInfoKeys = {
  getCamRecordSettings_: 'getCamRecordSettings_',
  getCamImageSettings_: 'getCamImageSettings_',
  getCameraMotion_: 'getCameraMotion_',
};

export const VideoElementReadyState = {
  0: `No information is available about the media resource.`,
  1: `Enough of the media resource has been retrieved that the metadata attributes are initialized. Seeking will no longer raise an exception.`,
  2: `Data is available for the current playback position, but not enough to actually play more than one frame.`,
  3: `Data for the current playback position as well as for at least a little bit of time into the future is available (in other words, at least two frames of video, for example).`,
  4: `Enough data is available—and the download rate is high enough—that the media can be played through to the end without interruption.`,
};

export const VideoControllersType = {
  BackwardSeekbar: 'BackwardSeekbar',
  ForwardSeekbar: 'ForwardSeekbar',
  DragSeekbar: 'DragSeekbar',
};

export const abortKeys = {
  fetchSearchEventImages: 'fetchSearchEventImages',
};

export const CallerKeys = {
  HomeVideo_handleHomeGroupChanged: 'HomeVideo/handleHomeGroupChanged',
  HomeVideo_watchMaxRetentionPeriodDays:
    'HomeVideo/watchMaxRetentionPeriodDays',
  HomeVideo_handleGetDate: 'HomeVideo/handleGetDate',
};

export const FragmentHoleType = {
  VideoOff: 'videoOff',
  SkipOrCodecChanged: 'skipOrCodecChanged',
  SkipOverlap: 'skipOverlap',
  CodecChanged: 'codecChanged',
};

export const HistoryCode = {
  Logout: 11011,
  ChangePassword: 11012,
  Snapshot: 11020,
  LiveVideoPlayback: 11082,
  RecordedVideoPlayback: 11083,
};

export const CLIP_NAME_ALLOWED_REGEX = /^[ぁ-んァ-ンー一-龠a-zA-Z0-9\-_ \s]+$/;

export const INPUT_WHITESPACE_REGEX =
  /[ \u00A0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\t\n\r\f\v]/;
